<template>
    <div  v-if="isLeserserviceOrHigher" class="delete-gp-nummer">
        <v-tooltip :left="left" :right="right" :top="top" :bottom="bottom">
            <template v-slot:activator="{ on }">
                <v-btn text icon small class="drei_60-btn ma-0" @click="show" v-on="on">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
            <div class="max-width-btn">
                Sie können die GP-Nummer eines Kunden entfernen, weil dieser seinen Account zum Beispiel mit
                einer falschen GP-Nr. verknüpft hat. Beim Entfernen wird die Verknüpfung zum SAP-Konto getrennt.
            </div>
        </v-tooltip>
        <v-dialog
            v-model="showDialog"
            max-width="500"
            persistent
        >
            <v-card>
                <v-card-title clas="title">GP-Nummer löschen</v-card-title>
                <v-card-text>
                    <p class="body-2">
                        Soll für diesen Kunden die Geschäftspartnernummer {{ contractorId }} wirklich gelöscht werden?
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="warning"
                            outlined
                            @click="close"
                            :disabled="loading"
                    >Abbrechen</v-btn>
                    <v-btn
                        color="error"
                        outlined
                        @click="remove"
                        :loading="loading && processing"
                        :disabled="loading"
                    >Löschen</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import Api from '@/api';

export default {
    name: 'DeleteGpNummer',
    props: ['ssoId', 'contractorId', 'contractorScope', 'contractorOriginal', 'tooltipPosition'],
    data() {
        return {
            showDialog: false,
            loading: false,
            processing: false,
        };
    },
    computed: {
        left() {
            return this.tooltipPosition === 'left';
        },
        right() {
            return this.tooltipPosition === 'right';
        },
        top() {
            return this.tooltipPosition === 'top';
        },
        bottom() {
            return this.tooltipPosition === 'bottom';
        },
        ...mapGetters(['isLeserserviceOrHigher']),
    },
    methods: {
        ...mapMutations('snackbar', ['success', 'info', 'error']),
        show() {
            this.showDialog = true;
        },
        close() {
            this.showDialog = false;
            this.info(`Das Löschen der GP '${this.contractorId}' für diesen Kunden wurde abgebrochen.`);
        },
        remove() {
            this.loading = true;
            this.processing = true;
            Api.customer.deleteCustomerGp(this.ssoId, this.contractorId, this.contractorScope, this.contractorOriginal)
                .then(() => {
                    this.success(`Das Löschen der GP '${this.contractorId}'`
                        + ' für diesen Kunden war erfolgreich.');
                })
                .catch(() => {
                    this.error(`Das Löschen der GP '${this.contractorId}'`
                        + ' für diesen Kunden ist fehlgeschlagen.');
                })
                .finally(() => {
                    this.$emit('reload');
                    this.loading = false;
                    this.processing = false;
                    this.showDialog = false;
                });
        },
    },
};
</script>

<style scoped lang="scss">
</style>
